type Props = {
  id: string
}

export const Jumplink = ({ id }: Props) => {
  return <div className="absolute top-[-110px] lgx:top-[-91px] " id={id}></div>
}
